import { DCDesignLicensing, DCLicensingInterval } from "../services/design_creator/types";

// #region intervalLabel
export const intervalLabel = (interval?: DCLicensingInterval | null): string => {
    return interval === 'YEARLY' ? 'year' : 'month';
};

// #region formatLicensingAmount
export const formatLicensingAmount = (amount: number, currency = 'USD'): string => {
    try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: (currency || 'USD').toUpperCase() }).format(amount);
    } catch {
        return `$${amount.toFixed(2)}`;
    }
};

// #region formatLicensingTerms
/**
 * The single source of truth for licensing wording. Used by the catalog card,
 * the add-to-storefront dialog and the licensee list so the terms never diverge
 * between the browse view and the thing the brand actually agrees to.
 */
export const formatLicensingTerms = (licensing?: DCDesignLicensing | null): string => {
    if (!licensing) return 'No licensing price set';

    if (licensing.model === 'PERCENTAGE') {
        const pct = licensing.percentage_value ?? 0;
        return `${pct}% of order total`;
    }

    const amount = formatLicensingAmount(licensing.flat_amount ?? 0, licensing.currency);
    return `${amount} / ${intervalLabel(licensing.flat_interval)}`;
};

// #region licensingCommitmentSentence
/** Plain-language cost commitment shown before the brand confirms an add. */
export const licensingCommitmentSentence = (licensing?: DCDesignLicensing | null): string => {
    if (!licensing) return 'This design has no licensing price.';

    if (licensing.model === 'PERCENTAGE') {
        const pct = licensing.percentage_value ?? 0;
        return `You will pay ${pct}% of every order total for this design.`;
    }

    const amount = formatLicensingAmount(licensing.flat_amount ?? 0, licensing.currency);
    return `${amount} will be charged every ${intervalLabel(licensing.flat_interval)}, auto-renewing until you turn it off.`;
};
